// extracted by mini-css-extract-plugin
export var carrierIcon = "_vg-0";
export var carrierLogo = "_vg-1";
export var detailsSection = "_vg-2";